import {uniqueId} from 'lodash';
import React, {useCallback, useEffect, useState} from 'react';

import {useLocalI18n} from '../../../../../../../data/hooks/i18nHooks';
import FilterButton from '../../FilterButton';
import Icon from '../../../../../../elements/icons/Icon';
import iconSrc from '../../../icons/favorited.png';
import strings from '../../BubblesFilter.i18n.csv';
import styles from '../../BubblesFilter.module.scss';
import { useHasFavoriteParticipants } from '../../../../../../../data/hooks/participant/useHasFavoriteParticipants';

const FilterFavorites = props => {
    const {event, filterParams, onFilterActivation} = props,
        i18n = useLocalI18n(strings),
        hasFavorites = useHasFavoriteParticipants(event.id),
        [filterId] = useState(uniqueId('filter-favorites-'));

    const handleToggle = useCallback(() => {
        return app.store.dispatch(
            app.actions.participants.setFilterParams(event.id, {
                ...(filterParams || {}),
                favorites: !filterParams?.favorites,
            })
        );
    }, [filterParams]);

    const handleFilterHover = useCallback(() => {
        onFilterActivation(filterId);
    }, []);

    if (!hasFavorites) return null;

    return (
        <FilterButton active={filterParams?.favorites} onClick={handleToggle} onMouseEnter={handleFilterHover} event={event} icon={iconSrc}>
            {i18n['favourites']}
        </FilterButton>
    );
};

export default FilterFavorites;
